import getArabicMap from "./ar"
import getEnglishMap from "./en"
import getHebrewMap from "./he"
import getRussianMap from "./ru"

const languageMap = {
    "ar-SA": getArabicMap,
    "he-IL": getHebrewMap,
    "en-US": getEnglishMap,
    "ru-RU": getRussianMap,
}

const getLanguageProvider = (language) => {
    const languageItem = languageMap[language]
    if (languageItem) {
        return languageItem()
    }
    throw new Error(`Language ${language} is not yet supported by Microspec Dashboard Builder.`)
}

export default getLanguageProvider